import { useHistory } from 'react-router-dom';
import CustomButton from '../CustomButton/CustomButton';
import styles from './UnauthorizedScreen.scss';
import { projetosRoute } from '../../library/Routes';
import { LogoProgramasEducacionais } from 'components/LogoProgramasEducacionais';
import unauthorized from './../../assets/images/unauthorized.gif';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { closeModal } from 'store/modules/ModalActions';
import { Fragment } from 'react';

const rootClassName = styles.rootClassName;

const UnauthorizedScreen = () => {
  const languageValues = useSelector((state: RootState) => state.languages.languageValues);
  const history = useHistory();
  const dispatch = useDispatch();

  const toHome = () => {
    dispatch(closeModal('ModalProgramaPeriodo'))
    history.push(projetosRoute.path);
  };

  return (
    <Fragment>
      <div className={rootClassName + '-container-401'}>
        <div className='container-images'>
          <LogoProgramasEducacionais width={200} />
          <img src={unauthorized} alt='icone-401' className={'icon-401'} loading='lazy' />
        </div>
        <div className='container-legend-401'>
          <p>{languageValues.naoAutorizado}</p>
        </div>
        <CustomButton
          label={languageValues.voltaInicio}
          theme='pufvYellow'
          className={rootClassName + '-main-button'}
          onClick={toHome}
        />
      </div>
    </Fragment>
  );
};

export default UnauthorizedScreen;